import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export function useOrganizationAccess(organizationId: string) {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['organization-access', user?.id, organizationId],
    queryFn: async () => {
      if (!user?.id) {
        return { hasAccess: false, membership: null };
      }
      
      const { data, error } = await supabase
        .from('user_organizations')
        .select('*')
        .eq('user_id', user.id)
        .eq('organization_id', organizationId)
        .eq('status', 'active')
        .maybeSingle();
      
      if (error) {
        console.error('Error checking organization access:', error);
        throw error;
      }
      
      return {
        hasAccess: !!data,
        membership: data
      };
    },
    enabled: !!user?.id && !!organizationId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
